import { Show, Suspense, onMount } from "solid-js";

// import Buoy from "@/components/Base/Buoy/Buoy.tsx";
import { Loading } from "@/components/Base/Loading/Loading";
import { useDialog } from "@/components/Dialogs/useDialog.ts";
import { useHeaderOpacityOnScroll } from "@/hooks/useScroll";
import { useViewportReflowFix } from "@/hooks/useViewportReflowFix";
import Cookies from "@/layouts/h5/components/Cookies";
import { getRealPath } from "@/lib/language";
import { deviceInfo } from "@/stores/deviceStore";
import { FlowProps } from "@/types/base";
import { useLocation } from "@solidjs/router";

import AppDownloadBanner from "./components/AppDownloadBanner";
import Footer from "./components/Footer";
import HomeHeader from "./components/Header/HomeHeader";
import BottomNavigation from "./components/Navigation/BottomNav";
import VerifyTip from "./components/VerifyTip";

export function H5LobbyLayout(props: FlowProps) {
  let scrollContainer!: HTMLDivElement;
  let bottomNavRef!: HTMLDivElement;

  const hiddenFooter = ["menu", "profile", "sports"];

  const { operateDialog } = useDialog();

  useViewportReflowFix(bottomNavRef);

  useHeaderOpacityOnScroll();

  onMount(() => {
    if (!localStorage.getItem("mionrs18Accepted")) {
      operateDialog("Minors18Popup", true);
    }
  });

  return (
    <div
      class={`h-screen-full overflow-y-auto ${deviceInfo.ios && deviceInfo.m_app == 10 ? "page-scroll-container" : ""}`}
      ref={scrollContainer}
    >
      <div class="fixed left-0 right-0 top-0 z-50 h-[48px]">
        <HomeHeader />
      </div>
      <div class="safe-main-padding min-h-screen pt-[48px]">
        <Suspense
          fallback={
            <div class="min-h-[calc(100vh-var(--header-height))]">
              <Loading />
            </div>
          }
        >
          {props.children}
          <Show
            when={
              !hiddenFooter.includes(
                getRealPath(useLocation().pathname).split("/")[0],
              )
            }
            fallback={<></>}
          >
            <Footer currentPath={useLocation().pathname} />
          </Show>
        </Suspense>
        <AppDownloadBanner />
      </div>
      <Cookies />
      <VerifyTip />
      <div
        class="fixed bottom-0 left-0 right-0 z-50"
        ref={(el) => (bottomNavRef = el)}
      >
        <BottomNavigation />
      </div>
    </div>
  );
}
